import axios from 'axios';

const production = !process.env.REACT_APP_NODE_ENV || process.env.REACT_APP_NODE_ENV === "production";
const API_BASE_URL =production ? process.env.REACT_APP_BASE_URL_PROD: process.env.REACT_APP_BASE_URL_DEV;
const API_AUTH_TOKEN = localStorage.getItem('token');

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${API_AUTH_TOKEN}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // Redirect user to the login page
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);
export const getOfferStatus = async () => {
  try {
    const response = await axiosInstance.get('/offerstatuses');
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error fetching advertisers:', error);
    throw error;
  }
};

export const addOfferStatus = async (offerType) => {
  try {
    const response = await axiosInstance.post('/offerstatus/add', offerType);
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error adding advertiser:', error);
    throw error;
  }
};

export const updateOfferStatus = async (id, updatedOfferType) => {
  try {
    const response = await axiosInstance.put(`/offerstatus/${id}`, updatedOfferType);
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error updating advertiser:', error);
    throw error;
  }
};

export const deleteOfferStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`/offerstatus/${id}`);
    if(response.status === 401){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      window.location.href = '/auth/login';
      return null;
    }else{
      return response.data;
    }
   
  } catch (error) {
    console.error('Error deleting advertiser:', error);
    throw error;
  }
};
